// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#org-content #inner-org-chart {
    position: relative;
}

#org-content .zoom-chart {
    position: absolute;
    top: 40px;
    right: 0;
    z-index: 1;
}

#org-content .zoom-chart .btn-zoom-chart {
    padding: 0 5px;
    cursor: pointer;
}

#org-content .zoom-chart button i {
    margin: 0;
    font-size: 2rem;
    color: #000;
}

#org-content .zoom-chart button i:hover {
    color: #0288d1;
}

#org-content .zoom-chart .btn-flat:focus {
    background-color: #ddd;
}

ol.organizational-chart .li-dept span.badge.new {
    position: absolute;
    margin: 0;
    min-width: auto;
    padding: 0px 5px;
    top: 50%;
    right: 5px;
    height: 18px;
    line-height: 18px;
    font-size: 10px;
    margin-top: -8px;
    background: #ffcc34;
    color: #000;
    font-weight: unset;
}

ol.organizational-chart .staff.active .detail {
    margin-top: 4px;
}

ol.organizational-chart .staff.active .image-circle {
    border: 3px solid #ff9800 !important;
    top: 1px !important;
}

ol.organizational-chart .staff.active {
    border: 3px solid #ff9800;
}

#org-content .div-dept {
    cursor: pointer;
    position: relative;
}

#org-content .btn-floating {
    /*background-color: #18c4da;*/
    background-color: #ffae36;
}

#org-content .level span:first-child {
    padding-left: 20px;
    padding-right: 20px;
    display: block;
    /*position: relative;*/
}

#org-content .btn-expend {
    position: absolute;
    left: 4px;
    top: 50%;
    margin-top: -10px;
}

#org-content #tmp-print .btn-expend {
    display: none;
}

#org-content .btn-floating.btn-small i {
    line-height: 22px;
}

#org-content .btn-small {
    line-height: 20px;
}

#org-content .btn-floating.btn-small {
    width: 20px;
    height: 20px;
}

#org-content .btn-select-all [type="checkbox"].filled-in:not(:checked)+span:not(.lever):after {
    height: 17px;
    width: 17px;
    top: 2px;
}

#org-content .btn-select-all [type="checkbox"].filled-in:checked+span:not(.lever):after {
    top: 3px;
    width: 16px;
    height: 16px;
}

#org-content .btn-select-all [type="checkbox"].filled-in:checked+span:not(.lever):before {
    top: 0px;
    left: 0px;
    width: 6px;
    height: 13px;
}

#org-content .btn-select-all [type="checkbox"]+span:not(.lever) {
    padding-left: 22px; 
}

#org-content .btn-select-all [type="checkbox"]+span:not(.lever) {
    font-size: 12px !important;
}

#org-content .btn-select-all {
    position: absolute;
    top: -14px;
    left: 5px;
    /*right: 5px;*/
}

#org-content #main-content {
    position: relative;
}

#org-content #main-btn {
    position: absolute;
    top: -90px;
    right: 20px;
}

#org-content #main-btn button {
    border-radius: 6px;
}

#org-content #btn-clear {
    margin-left: 10px;
}

#org-content #btn-view-user {
    float: right;
    margin-left: 10px;
    background-color: #06625a;
}

#org-content .btn-small.btn-user-role {
    line-height: 22px;
    height: 22px;
    padding-left: 3px;
    padding-right: 3px;
    margin-right: 5px;
    margin-top: -2px;
}

#org-content .box-manages,
#org-view-staff .box-manages {
    display: block;
    position: relative;
}

#org-content .box-manages .name,
#org-view-staff .box-manages .name {
    display: block;
    margin-right: 30px;
}

#org-content .box-manages .icon .btn-floating.btn-small,
#org-view-staff .box-manages .icon .btn-floating.btn-small {
    width: 22px;
    height: 22px
}

#org-content .box-manages .icon .btn-small,
#org-view-staff .box-manages .icon .btn-small {
    line-height: 22px;
    height: 22px;
    padding-left: 3px;
    padding-right: 3px;
    position: absolute;
    top: 0;
    right: 0;
}

#org-content .box-manages .icon .btn-floating.btn-small i,
#org-view-staff .box-manages .icon .btn-floating.btn-small i {
    line-height: 22px;
}

#org-content .pagination li.active {
    background-color: #26a69a!important;
}

#org-content #collap-header {   
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
}

#org-content .title {
    font-size: 14px;
}

.noselect,  #org-content #org-chart #tree div,
.noselect,  #org-content #org-chart #tree span {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }

#org-content #org-chart {
    border: 2px solid #607d8b;
    border-radius: 10px;
    margin-top: 15px;
    overflow: hidden;
}
#org-content #org-chart #select-type-chart {
    height: 40px;
    background: #1ed1c0;
    line-height: 40px;
    font-weight: bold;
    padding: 0 15px;
    font-size: 14px;
}

#org-content #org-chart #select-type-chart #title {
    font-size: 14px;
    float: left;
}

#org-content #org-chart #select-type-chart #radiogroup {
    font-size: 14px;
    float: right;
    color: #000;
}

#org-content #tree {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 20px 0px;
    min-height: 500px;
    display: grid;
    width: 100%;
    position: relative;
    padding-right: 20px;
}

#org-content #select-type-chart #radiogroup [type="radio"]+span {
    margin-left: 8px;
    color: #000;
    font-size: 14px;
}

#org-content #select-type-chart #radiogroup [type="radio"].with-gap:checked+span:before,
#org-content #select-type-chart #radiogroup [type="radio"].with-gap:checked+span:after {
    border: 2px solid #795548;
}

[type="radio"]:checked+span:after, [type="radio"].with-gap:checked+span:after {
    background-color: #795548;
}

#org-content #table-content {   
    margin-bottom: 15px;
    padding-top: 20px;
}

#org-content #table-content td {   
    vertical-align: top;
    font-size: 14px;
}

#org-content .td-photo {
    text-align: center;
}

#org-content .td-photo .image-circle {
    width: 46px;
    height: 46px;
    top: 9px;
}

#org-content .td-photo .image-circle i {
    font-size: 30px;
    margin-top: 7px;
}

#org-content .box-small-staff, 
#org-view-staff .box-small-staff {
    display: inline-block;
    position: relative;
    height: 30px;
    line-height: 30px;
    margin-right: 5px;
    margin-bottom: 5px;
}

#org-content .box-small-staff .image-circle, 
#org-view-staff .box-small-staff .image-circle {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 0px;
    left: 0px;
    margin-left: 0px;
}

#org-content .box-small-staff .image-circle i, 
#org-view-staff .box-small-staff .image-circle i {
    font-size: 20px;
    margin-top: 4px;
    margin-left: 4px;
}

#org-content .box-small-staff .text,
#org-view-staff .box-small-staff .text {
    padding-left: 35px;
    display: inline-block;
    line-height: 17px;
}

#org-content #top-content {
    margin-top: 16px;
    margin-bottom: 10px;
}

#org-content #top-content .filter-input-field {
    padding-bottom: 0px;
    position: relative;
}

#org-content #top-content #form-filter-request .filter-inputs.row {
    border-bottom: 0px;
}

#org-content .input-field {
    margin-top: 0px;
    margin-bottom: 0.8rem;
}

#org-content.inner-container .filter-inputs {
    grid-template-columns: auto auto auto auto;
}

#org-content #org-table {
    position: relative;
    padding-left: 18px;
    padding-right: 18px;
    padding-top: 20px;
    padding-bottom: 5px;
    border: 1px solid #ddd;
    border-radius: 10px;
    overflow: auto;
}

#org-content .box-select-limit {
    position: absolute;
    top: -9px;
    right: 0px;
}

ol.organizational-chart,
ol.organizational-chart ol,
ol.organizational-chart li,
ol.organizational-chart li > div {
    position: relative;
}

ol.organizational-chart,
ol.organizational-chart ol {
    list-style: none;
    margin: 0;
    padding: 0;
}

ol.organizational-chart {
    text-align: center;
}

ol.organizational-chart ol {
    padding-top: 1em;
}

ol.organizational-chart .staff-top-level {
    margin-top: 1em;
}

ol.organizational-chart .outer-staff-top-level {
    display: inline-block;
    width: 144px;
    padding: 0px !important;
}

ol.organizational-chart .staff-top-level::before {
    height: 1em!important;
    left: calc(50% - 1em) !important;
    width: 0.06em!important;
    background-color: #b7a6aa;
    content: '';
    position: absolute;
    top: -1em;
}

ol.organizational-chart ol:before,
ol.organizational-chart ol:after,
ol.organizational-chart li:before,
ol.organizational-chart li:after,
ol.organizational-chart > li > div:before,
ol.organizational-chart > li > div:after {
    background-color: #b7a6aa;
    content: '';
    position: absolute;
}

ol.organizational-chart ol > li {
    padding: 1em 0 0 0.7em;
}

ol.organizational-chart > li ol:before, 
ol.organizational-chart > li ol li ol:before {
    height: 1em;
    left: 50%;
    top: 0;
    width: 0.06em;
}

ol.organizational-chart > li ol li ol li ol:before {
    height: 1em;
    left: calc(50% - 0.3em);
    top: 0px;
    width: 0.3em;
    right: 0;
    border-bottom-right-radius: 5px;
    border-bottom: 1px solid #b7a6aa;
    border-right: 1px solid #b7a6aa;
    background: none;
    box-sizing: content-box;
}

*, *:before, *:after { box-sizing: border-box; 
    -ms-text-size-adjust:100%; -webkit-text-size-adjust:100%
}

ol.organizational-chart > li ol:after {
    height: 1px;
    left: 2px;
    top: 1em;
    width: 50%;
}

ol.organizational-chart > li ol li ol:after {
    height: 1em;
    left: 0px;
    top: 1em;
    width: calc(50% - 0.1em);
    right: 0;
    border-top-left-radius: 6px;
    border-top: 1px solid #b7a6aa;
    border-left: 1px solid #b7a6aa;
    background: none;
}

ol.organizational-chart > li ol > li:not(:last-of-type):before {
    height: 1px;
    left: 0;
    top: 2em;
    width: 0.7em;
}

ol.organizational-chart > li ol > li:not(:last-of-type):after {
    height: 100%;
    left: 0;
    top: 13px;
    width: 0.06em;
}

ol.organizational-chart > li ol > li:last-of-type:before {
    height: 1px;
    left: 0;
    top: 2em;
    width: 0.7em;
}

ol.organizational-chart > li ol > li > ol > li > ol > li:last-of-type:before {
    left: 0;
    width: 0.7em;
    border-bottom-left-radius: 6px !important;
    border-bottom-right-radius: 0px !important;
    border-top-right-radius: 0px !important;
    border-top-left-radius: 0px !important;
    border-bottom: 1px solid #b7a6aa !important;
    border-left: 1px solid #b7a6aa !important;
    border-top: 0px !important;
    border-right: 0px !important;
    background: #fff;
}

ol.organizational-chart > li ol > li:last-of-type:first-child:last-child::before {
    height: 2em !important;
    /*top: 13px !important;*/
    top: 0.6em !important;
}

ol.organizational-chart > li ol > li:last-of-type:last-child:before {
    height: 33px;
    top: 0px;
}

ol.organizational-chart .box-include-top-level {
    background: none !important;
    border-radius: 0px;
    padding: 0px;
    float: none;
    margin: 0px;
}

ol.organizational-chart .box-include-top-level.top-level-1,
ol.organizational-chart .box-include-top-level.top-level-2 {
    display: inline-block;
}

ol.organizational-chart .box-include-top-level.role-chart:not(.top-level-1, .top-level-2) {
    display: grid;
}

ol.organizational-chart .box-include-top-level:not(.top-level-1, .top-level-2) {
    display: list-item;
}

ol.organizational-chart .box-include-top-level > div:not(.before-staff, .staff) {
    border-radius: 6px;
    min-height: 2em;
    padding: 0.7em 0.7em;
    font-size: 12px;
}

ol.organizational-chart .box-include-top-level .staff {
    padding: 0.7em 0.7em;
    display: inline-block;
}

ol.organizational-chart .box-include-top-level .before-staff {
    height: 1em!important;
    margin-left: 50%!important;
    width: 0.06em!important;
    background-color: #b7a6aa;
    content: '';
    display: block;
}

ol.organizational-chart li > div {
    border-radius: 6px;
    min-height: 2em;
    padding: 0.7em 0.7em;
    font-size: 12px;
}

ol.organizational-chart .staff.hover {
    height: auto;
    margin-left: 0px;
    width: 144px;
    border-radius: 8px
}

ol.organizational-chart .staff.hover .photo {
    top: 2px;
    left: 50%;
    margin-left: -5px;
}

ol.organizational-chart .staff.hover .image-circle {
    width: 64px;
    height: 64px;
}

ol.organizational-chart .staff.hover .image-circle i {
    margin-top: 14px;
}

ol.organizational-chart .staff.hover .detail {
    font-size: 12px;
    margin-top: 64px;
    margin-left: 0px;
}

ol.organizational-chart .staff.hover .detail .position {
    line-height: 13px;
}

ol.organizational-chart .staff.hover .detail .full-name {
    line-height: 13px;
}

ol.organizational-chart .staff.hover .truncate {
    white-space: normal;
}

ol.organizational-chart .staff.hover:not(.card) .avatar-fallback {
    margin-left: 3px;
    margin-top: 4px;
}

ol.organizational-chart .staff {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 54px;
    margin-left: 24px;
    width: 120px;
    position: relative;
    cursor: pointer;
    /*display: inline-block;*/
}

ol.organizational-chart .staff .photo {
    position: absolute;
    top: -5px;
    left: 1px;
}

ol.organizational-chart .staff .detail {
    position: relative;
    margin-left: 23px;
    text-align: left;
    font-size: 11px;
    margin-top: 6px;
    line-height: 18px;
}

ol.organizational-chart .staff .detail .position {
    display: block;
    line-height: 10px;
    font-weight: bold;
    padding: 2px 0px;
}

ol.organizational-chart .staff .detail .full-name {
    display: block;
    line-height: 10px;
    padding: 2px 0px;
}

ol.organizational-chart .staff .image-circle {
    width: 56px;
    height: 56px;
    position: absolute;
    top: 4px;
    left: 50%;
    margin-left: -28px;
    background-color: #fff;
}

ol.organizational-chart .staff .image-circle i {
    font-size: 30px;
    margin-top: 9px;
    margin-left: 0px;
    color: #000;
}

/*** PRIMARY ***/
/*ol.organizational-chart > li > div {*/
ol.organizational-chart .level-1 {
    background-color: #01579b;
    color: #fff;
}
    
ol.organizational-chart .staff.level-1 {
    background-color: #039be5;
    color: #fff;
}

ol.organizational-chart > li > div:not(.staff.level-1):not(.level-1):before {
    bottom: 2em;
    height: 1px;
    right: -1em;
    width: 0.7em;
}

ol.organizational-chart > li > div:first-of-type:after {
    bottom: 0;
    height: 2em;
    right: -1em;
    width: 0.06em;
}

ol.organizational-chart > li > div + div {
    margin-top: 1em;
}

ol.organizational-chart > li > div + div:after {
    height: calc(100% + 1em);
    right: -1em;
    top: -1em;
    width: 0.06em;
}

/*** SECONDARY ***/
ol.organizational-chart > li > ol:before {
    left: inherit;
    right: 0;
}

ol.organizational-chart > li > ol:after {
    left: 0;
    width: 100%;
}

/*ol.organizational-chart > li > ol > li > div {*/
ol.organizational-chart .level-2 {
    background-color: #00695c;
    color: #fff;
}
    
/* ol.organizational-chart .staff.level-2 {
    background-color: #26a69a;
    color: #fff;
} */


/*** TERTIARY ***/
/*ol.organizational-chart > li > ol > li > ol > li > div {*/
ol.organizational-chart .level-3 {
    background-color: #0288d1;
    color: #fff;
}

/* ol.organizational-chart .staff.level-3 {
    background-color: #b3e5fc;
    color: #000;
} */


/*** QUATERNARY ***/
/*ol.organizational-chart > li > ol > li > ol > li > ol > li > div {*/
ol.organizational-chart .level-4 {
    background-color: #009688;
    color:#fff;
}

/* ol.organizational-chart .staff.level-4 {
    background-color: #1ed1c0;
    color: #fff;
} */

/*** QUINARY ***/
/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > div {*/
ol.organizational-chart .level-5 {
    background-color: #03b2c9;
    color: #fff;
}

/* ol.organizational-chart .staff.level-5 {
    background-color: #98eef9;
    color: #000;
} */

/*** QUINARY ***/
/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > ol >li > div {*/
ol.organizational-chart .level-6 {
    background-color: #f1ae4b; /*#616161;*/
    color: #fff;
}

/* ol.organizational-chart .staff.level-6 {
    background-color: #fdd8a2;
    color: #000;
} */

/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > ol >li > ol > li > div {*/
ol.organizational-chart .level-7 {
    background-color: #d1df4c;
}

/* ol.organizational-chart .staff.level-7 {
    background-color: #eef5ad;
    color: #000;
} */

ol.organizational-chart .level-8 {
    background-color: #f9e430;
    color: #000;
}

/* ol.organizational-chart .staff.level-8 {
    background-color: #fff176;
    color: #000;
} */

/* โหมด capture PNG: ตัดเงา แต่คงรูป/เส้น */
#tmp-tree.capture-for-download {
  background: #fff !important;
  position: absolute;
  left: -99999px;
  top: -99999px;
}

#tmp-tree.capture-for-download * {
  box-shadow: none !important;
  filter: none !important;
  mix-blend-mode: normal !important;
}

#tmp-tree.capture-for-download *::before,
#tmp-tree.capture-for-download *::after {
  box-shadow: none !important;
  filter: none !important;
  /* อย่าใส่ display:none / background:transparent / ปรับความกว้างตรงนี้ */
}

#tmp-tree.capture-for-download .image-circle {
  background-size: cover !important;
}


/*** MEDIA QUERIES ***/
@media only screen and ( min-width: 64px ) {

    ol.organizational-chart {
        margin-left: -1em;
        margin-right: -1em;
    }

    /* PRIMARY */
    ol.organizational-chart > li > div {
        display: inline-block;
        float: none;
        margin: 0 0.5em 0.5em 0.5em;
        vertical-align: bottom;
        padding: 10px 20px;
    }

    /* SECONDARY */
    ol.organizational-chart > li > ol > li > div {
        display: inline-block;
        float: none;
        margin: 0 0.5em 0em 0.5em;
        vertical-align: bottom;
        padding: 10px 20px;
    }

    ol.organizational-chart > li > div:only-of-type {
        margin-bottom: 0;
        /*width: calc((100% / 1) - 2em - 4px);*/
    }

    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2),
    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2) ~ div {
        width: calc((100% / 2) - 2em - 4px);
    }

    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3),
    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3) ~ div {
        width: calc((100% / 3) - 2em - 4px);
    }

    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4),
    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4) ~ div {
        width: calc((100% / 4) - 2em - 4px);
    }

    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5),
    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5) ~ div {
        width: calc((100% / 5) - 2em - 4px);
    }

    ol.organizational-chart > li > div:before,
    ol.organizational-chart > li > div:after {
        bottom: -1em!important;
        top: inherit!important;
    }

    ol.organizational-chart > li > div:not(.staff.level-1):not(.level-1):before {
        height: 1em!important;
        left: 50%!important;
        width: 0.06em!important;
    }

    ol.organizational-chart > li > div:only-of-type:after {
        display: none;
    }

    ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after,
    ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {
        bottom: -1em;
        height: 1px;
        width: calc(50% + 1em + 2px);
    }

    ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after {
        left: calc(50% + 2px);
    }

    ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {
        left: calc(-1em - 2px);
    }

    ol.organizational-chart > li > div + div:not(:last-of-type):after {
        height: 1px;
        left: -2em;
        width: calc(100% + 4em);
    }

    /* SECONDARY */
    ol.organizational-chart > li > ol,
    ol.organizational-chart > li > ol > li > ol {
        /*display: flex;
        flex-wrap: nowrap;*/
        display: table;
    }

    ol.organizational-chart > li > ol:before,
    ol.organizational-chart > li > ol > li:before, 
    ol.organizational-chart > li > ol > li > ol > li:before {
        height: 1.5em!important;
        left: 50%!important;
        top: 0!important;
    }

    ol.organizational-chart > li > ol:not(:first-child, :last-child):before,
    ol.organizational-chart > li > ol > li:not(:first-child, :last-child):before, 
    ol.organizational-chart > li > ol > li > ol > li:not(:first-child, :last-child):before {
        width: 0.06em!important;
    }

    ol.organizational-chart > li > ol:after,
        ol.organizational-chart > li > ol > li > ol:after {
        display: none;
    }

    ol.organizational-chart > li > ol > li, 
    ol.organizational-chart > li > ol > li > ol > li {
        /*flex-grow: 1;
        padding-left: 0.5em;
        padding-right: 0.5em;*/
        padding-top: 1em;
        display: table-cell;
        vertical-align: top;
    }

    /* First Child Leaf */
    ol.organizational-chart li:first-child::before {
        right: 0;
        border-top-left-radius: 6px;
        border-top: 1px solid #b7a6aa;
        border-left: 1px solid #b7a6aa;
        background: #fff;
    }

    ol.organizational-chart > li > ol > li:first-of-type:first-child:after,
    ol.organizational-chart > li > ol > li:last-of-type:first-child:after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:first-child:after,
    ol.organizational-chart > li > ol > li > ol > li:last-of-type:first-child:after {
        height: 1px;
        top: 0;
        width: calc(50% - 10px);
    }

    ol.organizational-chart > li > ol > li:first-of-type:first-child:after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:first-child:after {
        left: calc(50% + 10px);
    }
    /* END First Child Leaf */

    /* Last Child Leave*/
    ol.organizational-chart li:last-child::before {
        border-top-right-radius: 6px;
        border-top: 1px solid #b7a6aa;
        border-right: 1px solid #b7a6aa;
        background: #fff;
    }
    ol.organizational-chart > li > ol > li:first-of-type:last-child:after,
    ol.organizational-chart > li > ol > li:last-of-type:last-child:after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:last-child:after,
    ol.organizational-chart > li > ol > li > ol > li:last-of-type:last-child:after {
        height: 1px;
        top: 0;
        width: 50%;
    }

    ol.organizational-chart > li > ol > li:first-of-type:last-child:after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:last-child:after {
        left: calc(50% + 10px);
    }
    /* END Last Child Leave*/

    ol.organizational-chart > li > ol > li > ol > li {
        min-width: 130px;
        max-width: 180px;
    }

    ol.organizational-chart > li > ol > li:only-of-type, 
    ol.organizational-chart > li > ol > li > ol > li:only-of-type {
        padding-top: 0;
    }

    ol.organizational-chart > li > ol > li:only-of-type:before,
    ol.organizational-chart > li > ol > li:only-of-type:after,
    ol.organizational-chart > li > ol > li > ol > li:only-of-type:before,
    ol.organizational-chart > li > ol > li > ol > li:only-of-type:after {
        display: none;
    }

    ol.organizational-chart > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,
    ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type, :first-child, :last-child):after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,
    ol.organizational-chart > li > ol > li > ol > li:last-of-type:not(:only-of-type, :first-child, :last-child):after {
        height: 1px;
        top: 0;
        width: 50%;
    }

    ol.organizational-chart > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,
    ol.organizational-chart > li > ol > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after {
        left: 50%;
    }

    ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type):after, 
    ol.organizational-chart > li > ol > li > ol > li:last-of-type:not(:only-of-type):after {
        left: 0;
    }

    ol.organizational-chart > li > ol > li + li:not(:last-of-type):after,
    ol.organizational-chart > li > ol > li > ol > li + li:not(:last-of-type):after {
        height: 0.06em;
        left: 0;
        top: 0;
        width: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Org/org.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB,EAAE,iFAAiF;EACtG;;AAEF;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA;;;;;;IAMI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,SAAS;IACT,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,+BAA+B;IAC/B,gCAAgC;IAChC,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,uBACiE,sBAAsB;IACnF,yBAAyB,EAAE;AAC/B;;AAEA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;IACR,wBAAwB;IACxB,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,OAAO;IACP,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,yCAAyC;IACzC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,2CAA2C;IAC3C,yCAAyC;IACzC,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,gBAAgB;AAChB,uCAAuC;AACvC;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,SAAS;IACT,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA,iDAAiD;AACjD;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;GAGG;;;AAGH,iBAAiB;AACjB,2DAA2D;AAC3D;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;GAGG;;;AAGH,mBAAmB;AACnB,qEAAqE;AACrE;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;;;GAGG;;AAEH,gBAAgB;AAChB,+EAA+E;AAC/E;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;GAGG;;AAEH,gBAAgB;AAChB,wFAAwF;AACxF;IACI,yBAAyB,EAAE,WAAW;IACtC,WAAW;AACf;;AAEA;;;GAGG;;AAEH,kGAAkG;AAClG;IACI,yBAAyB;AAC7B;;AAEA;;;GAGG;;AAEH;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;GAGG;;AAEH,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA;EACE,iCAAiC;AACnC;;;AAGA,sBAAsB;AACtB;;IAEI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA,YAAY;IACZ;QACI,qBAAqB;QACrB,WAAW;QACX,2BAA2B;QAC3B,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA,cAAc;IACd;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,uCAAuC;IAC3C;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;;QAEI,mCAAmC;IACvC;;IAEA;;QAEI,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,YAAY;QACZ,WAAW;QACX,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;IAC3B;;IAEA,cAAc;IACd;;QAEI;2BACmB;QACnB,cAAc;IAClB;;IAEA;;;QAGI,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;;QAGI,uBAAuB;IAC3B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI;;8BAEsB;QACtB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA,qBAAqB;IACrB;QACI,QAAQ;QACR,2BAA2B;QAC3B,6BAA6B;QAC7B,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA;;;;QAII,WAAW;QACX,MAAM;QACN,uBAAuB;IAC3B;;IAEA;;QAEI,sBAAsB;IAC1B;IACA,yBAAyB;;IAEzB,oBAAoB;IACpB;QACI,4BAA4B;QAC5B,6BAA6B;QAC7B,+BAA+B;QAC/B,gBAAgB;IACpB;IACA;;;;QAII,WAAW;QACX,MAAM;QACN,UAAU;IACd;;IAEA;;QAEI,sBAAsB;IAC1B;IACA,wBAAwB;;IAExB;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;;;QAII,aAAa;IACjB;;IAEA;;;;QAII,WAAW;QACX,MAAM;QACN,UAAU;IACd;;IAEA;;QAEI,SAAS;IACb;;IAEA;;QAEI,OAAO;IACX;;IAEA;;QAEI,cAAc;QACd,OAAO;QACP,MAAM;QACN,WAAW;IACf;;AAEJ","sourcesContent":["#org-content #inner-org-chart {\r\n    position: relative;\r\n}\r\n\r\n#org-content .zoom-chart {\r\n    position: absolute;\r\n    top: 40px;\r\n    right: 0;\r\n    z-index: 1;\r\n}\r\n\r\n#org-content .zoom-chart .btn-zoom-chart {\r\n    padding: 0 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n#org-content .zoom-chart button i {\r\n    margin: 0;\r\n    font-size: 2rem;\r\n    color: #000;\r\n}\r\n\r\n#org-content .zoom-chart button i:hover {\r\n    color: #0288d1;\r\n}\r\n\r\n#org-content .zoom-chart .btn-flat:focus {\r\n    background-color: #ddd;\r\n}\r\n\r\nol.organizational-chart .li-dept span.badge.new {\r\n    position: absolute;\r\n    margin: 0;\r\n    min-width: auto;\r\n    padding: 0px 5px;\r\n    top: 50%;\r\n    right: 5px;\r\n    height: 18px;\r\n    line-height: 18px;\r\n    font-size: 10px;\r\n    margin-top: -8px;\r\n    background: #ffcc34;\r\n    color: #000;\r\n    font-weight: unset;\r\n}\r\n\r\nol.organizational-chart .staff.active .detail {\r\n    margin-top: 4px;\r\n}\r\n\r\nol.organizational-chart .staff.active .image-circle {\r\n    border: 3px solid #ff9800 !important;\r\n    top: 1px !important;\r\n}\r\n\r\nol.organizational-chart .staff.active {\r\n    border: 3px solid #ff9800;\r\n}\r\n\r\n#org-content .div-dept {\r\n    cursor: pointer;\r\n    position: relative;\r\n}\r\n\r\n#org-content .btn-floating {\r\n    /*background-color: #18c4da;*/\r\n    background-color: #ffae36;\r\n}\r\n\r\n#org-content .level span:first-child {\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    display: block;\r\n    /*position: relative;*/\r\n}\r\n\r\n#org-content .btn-expend {\r\n    position: absolute;\r\n    left: 4px;\r\n    top: 50%;\r\n    margin-top: -10px;\r\n}\r\n\r\n#org-content #tmp-print .btn-expend {\r\n    display: none;\r\n}\r\n\r\n#org-content .btn-floating.btn-small i {\r\n    line-height: 22px;\r\n}\r\n\r\n#org-content .btn-small {\r\n    line-height: 20px;\r\n}\r\n\r\n#org-content .btn-floating.btn-small {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n#org-content .btn-select-all [type=\"checkbox\"].filled-in:not(:checked)+span:not(.lever):after {\r\n    height: 17px;\r\n    width: 17px;\r\n    top: 2px;\r\n}\r\n\r\n#org-content .btn-select-all [type=\"checkbox\"].filled-in:checked+span:not(.lever):after {\r\n    top: 3px;\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n#org-content .btn-select-all [type=\"checkbox\"].filled-in:checked+span:not(.lever):before {\r\n    top: 0px;\r\n    left: 0px;\r\n    width: 6px;\r\n    height: 13px;\r\n}\r\n\r\n#org-content .btn-select-all [type=\"checkbox\"]+span:not(.lever) {\r\n    padding-left: 22px; \r\n}\r\n\r\n#org-content .btn-select-all [type=\"checkbox\"]+span:not(.lever) {\r\n    font-size: 12px !important;\r\n}\r\n\r\n#org-content .btn-select-all {\r\n    position: absolute;\r\n    top: -14px;\r\n    left: 5px;\r\n    /*right: 5px;*/\r\n}\r\n\r\n#org-content #main-content {\r\n    position: relative;\r\n}\r\n\r\n#org-content #main-btn {\r\n    position: absolute;\r\n    top: -90px;\r\n    right: 20px;\r\n}\r\n\r\n#org-content #main-btn button {\r\n    border-radius: 6px;\r\n}\r\n\r\n#org-content #btn-clear {\r\n    margin-left: 10px;\r\n}\r\n\r\n#org-content #btn-view-user {\r\n    float: right;\r\n    margin-left: 10px;\r\n    background-color: #06625a;\r\n}\r\n\r\n#org-content .btn-small.btn-user-role {\r\n    line-height: 22px;\r\n    height: 22px;\r\n    padding-left: 3px;\r\n    padding-right: 3px;\r\n    margin-right: 5px;\r\n    margin-top: -2px;\r\n}\r\n\r\n#org-content .box-manages,\r\n#org-view-staff .box-manages {\r\n    display: block;\r\n    position: relative;\r\n}\r\n\r\n#org-content .box-manages .name,\r\n#org-view-staff .box-manages .name {\r\n    display: block;\r\n    margin-right: 30px;\r\n}\r\n\r\n#org-content .box-manages .icon .btn-floating.btn-small,\r\n#org-view-staff .box-manages .icon .btn-floating.btn-small {\r\n    width: 22px;\r\n    height: 22px\r\n}\r\n\r\n#org-content .box-manages .icon .btn-small,\r\n#org-view-staff .box-manages .icon .btn-small {\r\n    line-height: 22px;\r\n    height: 22px;\r\n    padding-left: 3px;\r\n    padding-right: 3px;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n#org-content .box-manages .icon .btn-floating.btn-small i,\r\n#org-view-staff .box-manages .icon .btn-floating.btn-small i {\r\n    line-height: 22px;\r\n}\r\n\r\n#org-content .pagination li.active {\r\n    background-color: #26a69a!important;\r\n}\r\n\r\n#org-content #collap-header {   \r\n    position: relative;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    width: 100%;\r\n}\r\n\r\n#org-content .title {\r\n    font-size: 14px;\r\n}\r\n\r\n.noselect,  #org-content #org-chart #tree div,\r\n.noselect,  #org-content #org-chart #tree span {\r\n    -webkit-touch-callout: none; /* iOS Safari */\r\n    -webkit-user-select: none; /* Safari */\r\n    -khtml-user-select: none; /* Konqueror HTML */\r\n    -moz-user-select: none; /* Old versions of Firefox */\r\n    -ms-user-select: none; /* Internet Explorer/Edge */\r\n    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\r\n  }\r\n\r\n#org-content #org-chart {\r\n    border: 2px solid #607d8b;\r\n    border-radius: 10px;\r\n    margin-top: 15px;\r\n    overflow: hidden;\r\n}\r\n#org-content #org-chart #select-type-chart {\r\n    height: 40px;\r\n    background: #1ed1c0;\r\n    line-height: 40px;\r\n    font-weight: bold;\r\n    padding: 0 15px;\r\n    font-size: 14px;\r\n}\r\n\r\n#org-content #org-chart #select-type-chart #title {\r\n    font-size: 14px;\r\n    float: left;\r\n}\r\n\r\n#org-content #org-chart #select-type-chart #radiogroup {\r\n    font-size: 14px;\r\n    float: right;\r\n    color: #000;\r\n}\r\n\r\n#org-content #tree {\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    padding: 20px 0px;\r\n    min-height: 500px;\r\n    display: grid;\r\n    width: 100%;\r\n    position: relative;\r\n    padding-right: 20px;\r\n}\r\n\r\n#org-content #select-type-chart #radiogroup [type=\"radio\"]+span {\r\n    margin-left: 8px;\r\n    color: #000;\r\n    font-size: 14px;\r\n}\r\n\r\n#org-content #select-type-chart #radiogroup [type=\"radio\"].with-gap:checked+span:before,\r\n#org-content #select-type-chart #radiogroup [type=\"radio\"].with-gap:checked+span:after {\r\n    border: 2px solid #795548;\r\n}\r\n\r\n[type=\"radio\"]:checked+span:after, [type=\"radio\"].with-gap:checked+span:after {\r\n    background-color: #795548;\r\n}\r\n\r\n#org-content #table-content {   \r\n    margin-bottom: 15px;\r\n    padding-top: 20px;\r\n}\r\n\r\n#org-content #table-content td {   \r\n    vertical-align: top;\r\n    font-size: 14px;\r\n}\r\n\r\n#org-content .td-photo {\r\n    text-align: center;\r\n}\r\n\r\n#org-content .td-photo .image-circle {\r\n    width: 46px;\r\n    height: 46px;\r\n    top: 9px;\r\n}\r\n\r\n#org-content .td-photo .image-circle i {\r\n    font-size: 30px;\r\n    margin-top: 7px;\r\n}\r\n\r\n#org-content .box-small-staff, \r\n#org-view-staff .box-small-staff {\r\n    display: inline-block;\r\n    position: relative;\r\n    height: 30px;\r\n    line-height: 30px;\r\n    margin-right: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n#org-content .box-small-staff .image-circle, \r\n#org-view-staff .box-small-staff .image-circle {\r\n    width: 30px;\r\n    height: 30px;\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 0px;\r\n    margin-left: 0px;\r\n}\r\n\r\n#org-content .box-small-staff .image-circle i, \r\n#org-view-staff .box-small-staff .image-circle i {\r\n    font-size: 20px;\r\n    margin-top: 4px;\r\n    margin-left: 4px;\r\n}\r\n\r\n#org-content .box-small-staff .text,\r\n#org-view-staff .box-small-staff .text {\r\n    padding-left: 35px;\r\n    display: inline-block;\r\n    line-height: 17px;\r\n}\r\n\r\n#org-content #top-content {\r\n    margin-top: 16px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n#org-content #top-content .filter-input-field {\r\n    padding-bottom: 0px;\r\n    position: relative;\r\n}\r\n\r\n#org-content #top-content #form-filter-request .filter-inputs.row {\r\n    border-bottom: 0px;\r\n}\r\n\r\n#org-content .input-field {\r\n    margin-top: 0px;\r\n    margin-bottom: 0.8rem;\r\n}\r\n\r\n#org-content.inner-container .filter-inputs {\r\n    grid-template-columns: auto auto auto auto;\r\n}\r\n\r\n#org-content #org-table {\r\n    position: relative;\r\n    padding-left: 18px;\r\n    padding-right: 18px;\r\n    padding-top: 20px;\r\n    padding-bottom: 5px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    overflow: auto;\r\n}\r\n\r\n#org-content .box-select-limit {\r\n    position: absolute;\r\n    top: -9px;\r\n    right: 0px;\r\n}\r\n\r\nol.organizational-chart,\r\nol.organizational-chart ol,\r\nol.organizational-chart li,\r\nol.organizational-chart li > div {\r\n    position: relative;\r\n}\r\n\r\nol.organizational-chart,\r\nol.organizational-chart ol {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nol.organizational-chart {\r\n    text-align: center;\r\n}\r\n\r\nol.organizational-chart ol {\r\n    padding-top: 1em;\r\n}\r\n\r\nol.organizational-chart .staff-top-level {\r\n    margin-top: 1em;\r\n}\r\n\r\nol.organizational-chart .outer-staff-top-level {\r\n    display: inline-block;\r\n    width: 144px;\r\n    padding: 0px !important;\r\n}\r\n\r\nol.organizational-chart .staff-top-level::before {\r\n    height: 1em!important;\r\n    left: calc(50% - 1em) !important;\r\n    width: 0.06em!important;\r\n    background-color: #b7a6aa;\r\n    content: '';\r\n    position: absolute;\r\n    top: -1em;\r\n}\r\n\r\nol.organizational-chart ol:before,\r\nol.organizational-chart ol:after,\r\nol.organizational-chart li:before,\r\nol.organizational-chart li:after,\r\nol.organizational-chart > li > div:before,\r\nol.organizational-chart > li > div:after {\r\n    background-color: #b7a6aa;\r\n    content: '';\r\n    position: absolute;\r\n}\r\n\r\nol.organizational-chart ol > li {\r\n    padding: 1em 0 0 0.7em;\r\n}\r\n\r\nol.organizational-chart > li ol:before, \r\nol.organizational-chart > li ol li ol:before {\r\n    height: 1em;\r\n    left: 50%;\r\n    top: 0;\r\n    width: 0.06em;\r\n}\r\n\r\nol.organizational-chart > li ol li ol li ol:before {\r\n    height: 1em;\r\n    left: calc(50% - 0.3em);\r\n    top: 0px;\r\n    width: 0.3em;\r\n    right: 0;\r\n    border-bottom-right-radius: 5px;\r\n    border-bottom: 1px solid #b7a6aa;\r\n    border-right: 1px solid #b7a6aa;\r\n    background: none;\r\n    box-sizing: content-box;\r\n}\r\n\r\n*, *:before, *:after {\r\n    -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; \r\n    -ms-text-size-adjust:100%; -webkit-text-size-adjust:100%\r\n}\r\n\r\nol.organizational-chart > li ol:after {\r\n    height: 1px;\r\n    left: 2px;\r\n    top: 1em;\r\n    width: 50%;\r\n}\r\n\r\nol.organizational-chart > li ol li ol:after {\r\n    height: 1em;\r\n    left: 0px;\r\n    top: 1em;\r\n    width: calc(50% - 0.1em);\r\n    right: 0;\r\n    border-top-left-radius: 6px;\r\n    border-top: 1px solid #b7a6aa;\r\n    border-left: 1px solid #b7a6aa;\r\n    background: none;\r\n}\r\n\r\nol.organizational-chart > li ol > li:not(:last-of-type):before {\r\n    height: 1px;\r\n    left: 0;\r\n    top: 2em;\r\n    width: 0.7em;\r\n}\r\n\r\nol.organizational-chart > li ol > li:not(:last-of-type):after {\r\n    height: 100%;\r\n    left: 0;\r\n    top: 13px;\r\n    width: 0.06em;\r\n}\r\n\r\nol.organizational-chart > li ol > li:last-of-type:before {\r\n    height: 1px;\r\n    left: 0;\r\n    top: 2em;\r\n    width: 0.7em;\r\n}\r\n\r\nol.organizational-chart > li ol > li > ol > li > ol > li:last-of-type:before {\r\n    left: 0;\r\n    width: 0.7em;\r\n    border-bottom-left-radius: 6px !important;\r\n    border-bottom-right-radius: 0px !important;\r\n    border-top-right-radius: 0px !important;\r\n    border-top-left-radius: 0px !important;\r\n    border-bottom: 1px solid #b7a6aa !important;\r\n    border-left: 1px solid #b7a6aa !important;\r\n    border-top: 0px !important;\r\n    border-right: 0px !important;\r\n    background: #fff;\r\n}\r\n\r\nol.organizational-chart > li ol > li:last-of-type:first-child:last-child::before {\r\n    height: 2em !important;\r\n    /*top: 13px !important;*/\r\n    top: 0.6em !important;\r\n}\r\n\r\nol.organizational-chart > li ol > li:last-of-type:last-child:before {\r\n    height: 33px;\r\n    top: 0px;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level {\r\n    background: none !important;\r\n    border-radius: 0px;\r\n    padding: 0px;\r\n    float: none;\r\n    margin: 0px;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level.top-level-1,\r\nol.organizational-chart .box-include-top-level.top-level-2 {\r\n    display: inline-block;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level.role-chart:not(.top-level-1, .top-level-2) {\r\n    display: grid;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level:not(.top-level-1, .top-level-2) {\r\n    display: list-item;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level > div:not(.before-staff, .staff) {\r\n    border-radius: 6px;\r\n    min-height: 2em;\r\n    padding: 0.7em 0.7em;\r\n    font-size: 12px;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level .staff {\r\n    padding: 0.7em 0.7em;\r\n    display: inline-block;\r\n}\r\n\r\nol.organizational-chart .box-include-top-level .before-staff {\r\n    height: 1em!important;\r\n    margin-left: 50%!important;\r\n    width: 0.06em!important;\r\n    background-color: #b7a6aa;\r\n    content: '';\r\n    display: block;\r\n}\r\n\r\nol.organizational-chart li > div {\r\n    border-radius: 6px;\r\n    min-height: 2em;\r\n    padding: 0.7em 0.7em;\r\n    font-size: 12px;\r\n}\r\n\r\nol.organizational-chart .staff.hover {\r\n    height: auto;\r\n    margin-left: 0px;\r\n    width: 144px;\r\n    border-radius: 8px\r\n}\r\n\r\nol.organizational-chart .staff.hover .photo {\r\n    top: 2px;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .image-circle {\r\n    width: 64px;\r\n    height: 64px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .image-circle i {\r\n    margin-top: 14px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .detail {\r\n    font-size: 12px;\r\n    margin-top: 64px;\r\n    margin-left: 0px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .detail .position {\r\n    line-height: 13px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .detail .full-name {\r\n    line-height: 13px;\r\n}\r\n\r\nol.organizational-chart .staff.hover .truncate {\r\n    white-space: normal;\r\n}\r\n\r\nol.organizational-chart .staff.hover:not(.card) .avatar-fallback {\r\n    margin-left: 3px;\r\n    margin-top: 4px;\r\n}\r\n\r\nol.organizational-chart .staff {\r\n    border-top-right-radius: 30px;\r\n    border-bottom-right-radius: 30px;\r\n    border-top-left-radius: 0px;\r\n    border-bottom-left-radius: 0px;\r\n    height: 54px;\r\n    margin-left: 24px;\r\n    width: 120px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    /*display: inline-block;*/\r\n}\r\n\r\nol.organizational-chart .staff .photo {\r\n    position: absolute;\r\n    top: -5px;\r\n    left: 1px;\r\n}\r\n\r\nol.organizational-chart .staff .detail {\r\n    position: relative;\r\n    margin-left: 23px;\r\n    text-align: left;\r\n    font-size: 11px;\r\n    margin-top: 6px;\r\n    line-height: 18px;\r\n}\r\n\r\nol.organizational-chart .staff .detail .position {\r\n    display: block;\r\n    line-height: 10px;\r\n    font-weight: bold;\r\n    padding: 2px 0px;\r\n}\r\n\r\nol.organizational-chart .staff .detail .full-name {\r\n    display: block;\r\n    line-height: 10px;\r\n    padding: 2px 0px;\r\n}\r\n\r\nol.organizational-chart .staff .image-circle {\r\n    width: 56px;\r\n    height: 56px;\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 50%;\r\n    margin-left: -28px;\r\n    background-color: #fff;\r\n}\r\n\r\nol.organizational-chart .staff .image-circle i {\r\n    font-size: 30px;\r\n    margin-top: 9px;\r\n    margin-left: 0px;\r\n    color: #000;\r\n}\r\n\r\n/*** PRIMARY ***/\r\n/*ol.organizational-chart > li > div {*/\r\nol.organizational-chart .level-1 {\r\n    background-color: #01579b;\r\n    color: #fff;\r\n}\r\n    \r\nol.organizational-chart .staff.level-1 {\r\n    background-color: #039be5;\r\n    color: #fff;\r\n}\r\n\r\nol.organizational-chart > li > div:not(.staff.level-1):not(.level-1):before {\r\n    bottom: 2em;\r\n    height: 1px;\r\n    right: -1em;\r\n    width: 0.7em;\r\n}\r\n\r\nol.organizational-chart > li > div:first-of-type:after {\r\n    bottom: 0;\r\n    height: 2em;\r\n    right: -1em;\r\n    width: 0.06em;\r\n}\r\n\r\nol.organizational-chart > li > div + div {\r\n    margin-top: 1em;\r\n}\r\n\r\nol.organizational-chart > li > div + div:after {\r\n    height: calc(100% + 1em);\r\n    right: -1em;\r\n    top: -1em;\r\n    width: 0.06em;\r\n}\r\n\r\n/*** SECONDARY ***/\r\nol.organizational-chart > li > ol:before {\r\n    left: inherit;\r\n    right: 0;\r\n}\r\n\r\nol.organizational-chart > li > ol:after {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n/*ol.organizational-chart > li > ol > li > div {*/\r\nol.organizational-chart .level-2 {\r\n    background-color: #00695c;\r\n    color: #fff;\r\n}\r\n    \r\n/* ol.organizational-chart .staff.level-2 {\r\n    background-color: #26a69a;\r\n    color: #fff;\r\n} */\r\n\r\n\r\n/*** TERTIARY ***/\r\n/*ol.organizational-chart > li > ol > li > ol > li > div {*/\r\nol.organizational-chart .level-3 {\r\n    background-color: #0288d1;\r\n    color: #fff;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-3 {\r\n    background-color: #b3e5fc;\r\n    color: #000;\r\n} */\r\n\r\n\r\n/*** QUATERNARY ***/\r\n/*ol.organizational-chart > li > ol > li > ol > li > ol > li > div {*/\r\nol.organizational-chart .level-4 {\r\n    background-color: #009688;\r\n    color:#fff;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-4 {\r\n    background-color: #1ed1c0;\r\n    color: #fff;\r\n} */\r\n\r\n/*** QUINARY ***/\r\n/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > div {*/\r\nol.organizational-chart .level-5 {\r\n    background-color: #03b2c9;\r\n    color: #fff;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-5 {\r\n    background-color: #98eef9;\r\n    color: #000;\r\n} */\r\n\r\n/*** QUINARY ***/\r\n/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > ol >li > div {*/\r\nol.organizational-chart .level-6 {\r\n    background-color: #f1ae4b; /*#616161;*/\r\n    color: #fff;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-6 {\r\n    background-color: #fdd8a2;\r\n    color: #000;\r\n} */\r\n\r\n/*ol.organizational-chart > li > ol > li > ol > li > ol > li > ol > li > ol >li > ol > li > div {*/\r\nol.organizational-chart .level-7 {\r\n    background-color: #d1df4c;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-7 {\r\n    background-color: #eef5ad;\r\n    color: #000;\r\n} */\r\n\r\nol.organizational-chart .level-8 {\r\n    background-color: #f9e430;\r\n    color: #000;\r\n}\r\n\r\n/* ol.organizational-chart .staff.level-8 {\r\n    background-color: #fff176;\r\n    color: #000;\r\n} */\r\n\r\n/* โหมด capture PNG: ตัดเงา แต่คงรูป/เส้น */\r\n#tmp-tree.capture-for-download {\r\n  background: #fff !important;\r\n  position: absolute;\r\n  left: -99999px;\r\n  top: -99999px;\r\n}\r\n\r\n#tmp-tree.capture-for-download * {\r\n  box-shadow: none !important;\r\n  filter: none !important;\r\n  mix-blend-mode: normal !important;\r\n}\r\n\r\n#tmp-tree.capture-for-download *::before,\r\n#tmp-tree.capture-for-download *::after {\r\n  box-shadow: none !important;\r\n  filter: none !important;\r\n  /* อย่าใส่ display:none / background:transparent / ปรับความกว้างตรงนี้ */\r\n}\r\n\r\n#tmp-tree.capture-for-download .image-circle {\r\n  background-size: cover !important;\r\n}\r\n\r\n\r\n/*** MEDIA QUERIES ***/\r\n@media only screen and ( min-width: 64px ) {\r\n\r\n    ol.organizational-chart {\r\n        margin-left: -1em;\r\n        margin-right: -1em;\r\n    }\r\n\r\n    /* PRIMARY */\r\n    ol.organizational-chart > li > div {\r\n        display: inline-block;\r\n        float: none;\r\n        margin: 0 0.5em 0.5em 0.5em;\r\n        vertical-align: bottom;\r\n        padding: 10px 20px;\r\n    }\r\n\r\n    /* SECONDARY */\r\n    ol.organizational-chart > li > ol > li > div {\r\n        display: inline-block;\r\n        float: none;\r\n        margin: 0 0.5em 0em 0.5em;\r\n        vertical-align: bottom;\r\n        padding: 10px 20px;\r\n    }\r\n\r\n    ol.organizational-chart > li > div:only-of-type {\r\n        margin-bottom: 0;\r\n        /*width: calc((100% / 1) - 2em - 4px);*/\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2),\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(2) ~ div {\r\n        width: calc((100% / 2) - 2em - 4px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3),\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(3) ~ div {\r\n        width: calc((100% / 3) - 2em - 4px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4),\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(4) ~ div {\r\n        width: calc((100% / 4) - 2em - 4px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5),\r\n    ol.organizational-chart > li > div:first-of-type:nth-last-of-type(5) ~ div {\r\n        width: calc((100% / 5) - 2em - 4px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:before,\r\n    ol.organizational-chart > li > div:after {\r\n        bottom: -1em!important;\r\n        top: inherit!important;\r\n    }\r\n\r\n    ol.organizational-chart > li > div:not(.staff.level-1):not(.level-1):before {\r\n        height: 1em!important;\r\n        left: 50%!important;\r\n        width: 0.06em!important;\r\n    }\r\n\r\n    ol.organizational-chart > li > div:only-of-type:after {\r\n        display: none;\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after,\r\n    ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {\r\n        bottom: -1em;\r\n        height: 1px;\r\n        width: calc(50% + 1em + 2px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:first-of-type:not(:only-of-type):after {\r\n        left: calc(50% + 2px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div:last-of-type:not(:only-of-type):after {\r\n        left: calc(-1em - 2px);\r\n    }\r\n\r\n    ol.organizational-chart > li > div + div:not(:last-of-type):after {\r\n        height: 1px;\r\n        left: -2em;\r\n        width: calc(100% + 4em);\r\n    }\r\n\r\n    /* SECONDARY */\r\n    ol.organizational-chart > li > ol,\r\n    ol.organizational-chart > li > ol > li > ol {\r\n        /*display: flex;\r\n        flex-wrap: nowrap;*/\r\n        display: table;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol:before,\r\n    ol.organizational-chart > li > ol > li:before, \r\n    ol.organizational-chart > li > ol > li > ol > li:before {\r\n        height: 1.5em!important;\r\n        left: 50%!important;\r\n        top: 0!important;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol:not(:first-child, :last-child):before,\r\n    ol.organizational-chart > li > ol > li:not(:first-child, :last-child):before, \r\n    ol.organizational-chart > li > ol > li > ol > li:not(:first-child, :last-child):before {\r\n        width: 0.06em!important;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol:after,\r\n        ol.organizational-chart > li > ol > li > ol:after {\r\n        display: none;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li, \r\n    ol.organizational-chart > li > ol > li > ol > li {\r\n        /*flex-grow: 1;\r\n        padding-left: 0.5em;\r\n        padding-right: 0.5em;*/\r\n        padding-top: 1em;\r\n        display: table-cell;\r\n        vertical-align: top;\r\n    }\r\n\r\n    /* First Child Leaf */\r\n    ol.organizational-chart li:first-child::before {\r\n        right: 0;\r\n        border-top-left-radius: 6px;\r\n        border-top: 1px solid #b7a6aa;\r\n        border-left: 1px solid #b7a6aa;\r\n        background: #fff;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:first-of-type:first-child:after,\r\n    ol.organizational-chart > li > ol > li:last-of-type:first-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:first-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:last-of-type:first-child:after {\r\n        height: 1px;\r\n        top: 0;\r\n        width: calc(50% - 10px);\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:first-of-type:first-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:first-child:after {\r\n        left: calc(50% + 10px);\r\n    }\r\n    /* END First Child Leaf */\r\n\r\n    /* Last Child Leave*/\r\n    ol.organizational-chart li:last-child::before {\r\n        border-top-right-radius: 6px;\r\n        border-top: 1px solid #b7a6aa;\r\n        border-right: 1px solid #b7a6aa;\r\n        background: #fff;\r\n    }\r\n    ol.organizational-chart > li > ol > li:first-of-type:last-child:after,\r\n    ol.organizational-chart > li > ol > li:last-of-type:last-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:last-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:last-of-type:last-child:after {\r\n        height: 1px;\r\n        top: 0;\r\n        width: 50%;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:first-of-type:last-child:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:last-child:after {\r\n        left: calc(50% + 10px);\r\n    }\r\n    /* END Last Child Leave*/\r\n\r\n    ol.organizational-chart > li > ol > li > ol > li {\r\n        min-width: 130px;\r\n        max-width: 180px;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:only-of-type, \r\n    ol.organizational-chart > li > ol > li > ol > li:only-of-type {\r\n        padding-top: 0;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:only-of-type:before,\r\n    ol.organizational-chart > li > ol > li:only-of-type:after,\r\n    ol.organizational-chart > li > ol > li > ol > li:only-of-type:before,\r\n    ol.organizational-chart > li > ol > li > ol > li:only-of-type:after {\r\n        display: none;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,\r\n    ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type, :first-child, :last-child):after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,\r\n    ol.organizational-chart > li > ol > li > ol > li:last-of-type:not(:only-of-type, :first-child, :last-child):after {\r\n        height: 1px;\r\n        top: 0;\r\n        width: 50%;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after,\r\n    ol.organizational-chart > li > ol > li > ol > li:first-of-type:not(:only-of-type, :first-child, :last-child):after {\r\n        left: 50%;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li:last-of-type:not(:only-of-type):after, \r\n    ol.organizational-chart > li > ol > li > ol > li:last-of-type:not(:only-of-type):after {\r\n        left: 0;\r\n    }\r\n\r\n    ol.organizational-chart > li > ol > li + li:not(:last-of-type):after,\r\n    ol.organizational-chart > li > ol > li > ol > li + li:not(:last-of-type):after {\r\n        height: 0.06em;\r\n        left: 0;\r\n        top: 0;\r\n        width: 100%;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
